export const enableIntercom = () => {
    return document.domain === "test.findd.io" || document.domain === "dev.findd.io" || document.domain === "staging.findd.io" || document.domain === "app.findd.io"
}

export const getCurrentEnviornment = () => {
    const currentHost = window.location.host
    let env = ""
    switch (currentHost) {
        case "test.findd.io":
            env = "TEST"
            break

        case "staging.findd.io":
            env = "STAGING"
            break

        case "dev.findd.io":
            env = "DEV"
            break

        case "app.findd.io":
            env = "PROD"
            break

        default:
            break
    }
    return env
}

if (enableIntercom()) {
    // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/n9mo4v5d'
    var appId = getCurrentEnviornment() === "PROD" ? "n9mo4v5d" : "hoo3xsbf"
    var w = window
    var ic = w.Intercom
    if (typeof ic === "function") {
        ic("reattach_activator")
        ic("update", w.intercomSettings)
    } else {
        var d = document
        var i = function () {
            i.c(arguments)
        }
        i.q = []
        i.c = function (args) {
            i.q.push(args)
        }
        w.Intercom = i
        var l = function () {
            var s = d.createElement("script")
            s.type = "text/javascript"
            s.async = true
            s.src = "https://widget.intercom.io/widget/" + appId
            var x = d.getElementsByTagName("script")[0]
            x.parentNode.insertBefore(s, x)
        }
        if (w.attachEvent) {
            w.attachEvent("onload", l)
        } else {
            w.addEventListener("load", l, false)
        }
    }

    // Moveable Intercom
    var intercomStartBtnElement = null
    var intercomFrameBtnElement = null
    var startBtnElementLeft = 0
    var intercomStartBtnFinder = setInterval(() => {
        intercomStartBtnElement = document.getElementsByClassName("intercom-launcher")[0]
        if (intercomStartBtnElement) {
            clearInterval(intercomStartBtnFinder)
            startBtnDrag(intercomStartBtnElement)
        }
    }, 1000)
}

function startBtnDrag(btnElement) {
    var pos1 = 0, pos2 = 0
    btnElement.onmousedown = dragMouseDown

    function dragMouseDown(e) {
        pos2 = e.clientX
        btnElement.onmouseup = closeDragElement
        btnElement.onmousemove = elementDrag
    }

    function elementDrag(e) {
        pos1 = pos2 - e.clientX
        pos2 = e.clientX
        btnElement.style.left = (btnElement.offsetLeft - pos1) + "px"
    }

    function closeDragElement() {
        startBtnElementLeft = btnElement.offsetLeft
        btnElement.onmouseup = null
        btnElement.onmousemove = null
        moveableFrameBtn()
    }
}

function moveableFrameBtn() {
    var intercomFrameBtnFinder = setInterval(() => {
        intercomFrameBtnElement = document.getElementsByClassName("intercom-launcher-frame")[0]
        if (intercomFrameBtnElement) {
            intercomFrameBtnElement.style.left = startBtnElementLeft + "px"
            clearInterval(intercomFrameBtnFinder)
            frameBtnDrag(intercomFrameBtnElement)
        }
    }, 0)
}

function frameBtnDrag(btnElement) {
    var pos1 = 0, pos2 = 0
    var moveableElement = btnElement.contentDocument
    moveableElement.onmousedown = dragMouseDown

    function dragMouseDown(e) {
        pos2 = e.clientX
        moveableElement.onmouseup = closeDragElement
        moveableElement.onmousemove = elementDrag
    }

    function elementDrag(e) {
        btnElement.style.pointerEvents = "none"
        pos1 = pos2 - e.clientX
        btnElement.style.left = (btnElement.offsetLeft - pos1) + "px"
    }

    function closeDragElement() {
        moveableElement.onmouseup = null
        moveableElement.onmousemove = null
        btnElement.style.pointerEvents = "auto"
    }
}